// extracted by mini-css-extract-plugin
export default {"calenderEventsMainSection":"meetingPortraitSection_calenderEventsMainSection__D0U9i"};